import { isKnownProjectType } from '@/constants/projectTypes'
import type { Project } from '@/types'

const STORAGE_PREFIX = 'escribonauta-project-shell:'

export type ProjectShell = {
  title: string
  type: string
  status: string
}

function storageKey(projectId: string): string {
  return `${STORAGE_PREFIX}${projectId}`
}

export function readProjectShell(projectId: string): ProjectShell | null {
  if (!projectId || typeof localStorage === 'undefined') return null

  try {
    const raw = localStorage.getItem(storageKey(projectId))
    if (!raw) return null
    const parsed = JSON.parse(raw) as Partial<ProjectShell>
    if (!parsed.title || !isKnownProjectType(parsed.type)) return null
    return {
      title: parsed.title,
      type: parsed.type,
      status: parsed.status || '',
    }
  } catch (error) {
    console.error('Error reading project shell:', error)
    return null
  }
}

export function writeProjectShell(projectId: string, shell: ProjectShell): void {
  if (!projectId || !isKnownProjectType(shell.type) || typeof localStorage === 'undefined') return

  try {
    localStorage.setItem(storageKey(projectId), JSON.stringify(shell))
  } catch (error) {
    console.error('Error writing project shell:', error)
  }
}

/** Enough of a project for the editor to mount before the server responds. */
export function projectFromShell(projectId: string, shell: ProjectShell): Project {
  return {
    _id: projectId,
    title: shell.title,
    synopsis: '',
    genres: [],
    status: shell.status,
    type: shell.type,
    pinned: false,
    userId: '',
    createdAt: '',
    updatedAt: '',
    chapters: [],
  }
}
